<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Create a New Supplier Payment</h4>
                <p class="text-subtitle-1">Supplier Payment Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn @click="exchangeRateIndexShown = true" depressed block>
                    <v-icon left>mdi-chart-areaspline-variant</v-icon>
                    currency exchange
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <PurchasePaymentForm
                    v-model="data"
                    ref="form"
                    :exchange-rate-index-shown.sync="exchangeRateIndexShown"
                    />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block color="primary" @click="handleSave" :loading="loading">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="handleCancel">
                    cancel
                </v-btn>
            </v-col>
        </v-row>
            <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import PurchasePaymentForm from './../../components/purchase/PurchasePaymentForm.vue';
import PAlert from './../../components/common/PAlert';
import { v4 as uuid } from 'uuid';

import { mapActions, mapGetters } from 'vuex';

export default {
    name: "PurchasePaymentCreateView",
    components: {
        PurchasePaymentForm,
        PAlert,
    },
    data() {
        return {
            loading: false,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
            data: null,
            perm: permissions,
            idempotentKey: null,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "purchase/payment/create",
            snackbar: "ui/snackbar/show"
        }),
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleSave() {
            this.alert = {...this.alert, content: "Are you sure you want to save?", value: true, callback: this.save }
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.push({name: "PurchasePaymentDisplay", params: {id: response.data.id}})
                this.snackbar({text: "Payment Created", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false;
            });
        },
        handleList() {
            this.$router.push({name: "PurchasePaymentList"})
        },
        handleCancel() {
            this.alert = {...this.alert, content: "Are you sure you want to discard changes?", value: true, callback: this.cancel }
        },
        cancel() {
            this.$router.back();
        }
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>